export const heroData = {
  title: "顶级娱乐体验 · 尽在银河",
  subtitle: "汇聚海量游戏资源、豪华会员礼遇与安全可靠的游戏环境，银河娱乐为您开启尊享娱乐之旅",
  ctaPrimary: "立即注册",
  ctaSecondary: "了解更多",
  stats: [
    { value: "10,000+", label: "精品游戏" },
    { value: "500万+", label: "活跃会员" },
    { value: "24/7", label: "全天候服务" },
    { value: "99.9%", label: "安全稳定性" },
  ],
};

export const features = [
  {
    icon: "ri-gamepad-line",
    title: "海量游戏资源",
    description: "汇聚全球顶级游戏开发商数千款精品游戏，涵盖电子游艺、真人荷官、体育竞技等多元品类，持续更新最新游戏内容，满足不同玩家的娱乐偏好。",
  },
  {
    icon: "ri-vip-crown-line",
    title: "豪华会员礼遇",
    description: "多层级会员体系，享有专属客服、优先提款、生日礼遇、积分兑换等尊享特权，让每一位会员感受无与伦比的尊贵体验。",
  },
  {
    icon: "ri-shield-check-line",
    title: "安全可靠保障",
    description: "采用国际领先的SSL加密技术与多重安全防护体系，所有游戏均经过权威机构认证，确保资金安全与游戏公平性，让您放心畅玩。",
  },
  {
    icon: "ri-smartphone-line",
    title: "多端无缝体验",
    description: "支持PC端、移动端、平板等多平台无缝切换，无论您身在何处，都能享受流畅稳定的娱乐体验，随时随地畅享精彩。",
  },
];

export const categories = [
  {
    id: "slots",
    name: "电子游艺",
    icon: "ri-gamepad-line",
    description: "千款热门老虎机与电子游戏，高额奖金等您来拿",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20colorful%20casino%20slot%20machine%20with%20glowing%20reels%20and%20golden%20accents%20on%20dark%20luxurious%20background%2C%20neon%20lights%2C%20premium%20gaming%20atmosphere%2C%20elegant%20gold%20and%20amber%20color%20scheme%2C%20cinematic%20lighting%2C%203D%20render%2C%20high%20detail%2C%20glamorous%20casino%20style&width=800&height=600&seq=cat-slots-01&orientation=landscape",
  },
  {
    id: "live",
    name: "真人荷官",
    icon: "ri-user-voice-line",
    description: "真实赌场氛围，专业荷官实时互动，身临其境的体验",
    image: "https://readdy.ai/api/search-image?query=Elegant%20live%20dealer%20casino%20table%20with%20professional%20dealers%20in%20formal%20attire%2C%20warm%20golden%20lighting%2C%20luxurious%20dark%20wood%20interior%2C%20gaming%20chips%20and%20cards%2C%20premium%20atmosphere%2C%20soft%20bokeh%20background%2C%20high-end%20casino%20photography%2C%20golden%20and%20amber%20tones&width=800&height=600&seq=cat-live-01&orientation=landscape",
  },
  {
    id: "sports",
    name: "体育竞技",
    icon: "ri-football-line",
    description: "全球赛事全覆盖，实时赔率更新，激情体育投注体验",
    image: "https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20with%20dramatic%20stadium%20lights%2C%20blurred%20athletes%20in%20action%2C%20golden%20hour%20lighting%2C%20premium%20sports%20atmosphere%2C%20dark%20elegant%20color%20palette%20with%20golden%20highlights%2C%20cinematic%20wide%20shot%2C%20high%20contrast%2C%20sports%20photography%20style&width=800&height=600&seq=cat-sports-01&orientation=landscape",
  },
  {
    id: "table",
    name: "棋牌桌游",
    icon: "ri-billiards-line",
    description: "经典棋牌游戏合集，与全球玩家切磋技艺，智趣无穷",
    image: "https://readdy.ai/api/search-image?query=Luxurious%20poker%20and%20card%20table%20with%20green%20felt%20surface%2C%20golden%20chips%20stacked%2C%20playing%20cards%20spread%2C%20dark%20elegant%20room%20with%20warm%20ambient%20lighting%2C%20premium%20casino%20interior%2C%20soft%20golden%20glow%2C%20high-end%20photography%2C%20rich%20amber%20and%20dark%20wood%20tones&width=800&height=600&seq=cat-table-01&orientation=landscape",
  },
  {
    id: "fishing",
    name: "捕鱼游戏",
    icon: "ri-anchor-line",
    description: "刺激的深海捕鱼体验，多人同场竞技，欢乐无限",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20underwater%20gaming%20scene%20with%20colorful%20tropical%20fish%20and%20marine%20life%2C%20animated%20style%2C%20glowing%20coral%20reef%2C%20deep%20blue%20ocean%20background%20with%20light%20rays%2C%20playful%20arcade%20gaming%20aesthetic%2C%20rich%20colors%2C%20digital%20art%2C%20immersive%20underwater%20atmosphere&width=800&height=600&seq=cat-fish-01&orientation=landscape",
  },
  {
    id: "jackpot",
    name: "累积奖池",
    icon: "ri-treasure-map-line",
    description: "超大奖池持续累积，一朝中奖改变人生，梦想触手可及",
    image: "https://readdy.ai/api/search-image?query=Majestic%20golden%20treasure%20chest%20overflowing%20with%20gold%20coins%20and%20gems%2C%20dramatic%20spotlight%20effect%2C%20dark%20luxurious%20background%20with%20sparkle%20particles%2C%20grand%20prize%20atmosphere%2C%20opulent%20golden%20tones%2C%20cinematic%20lighting%2C%203D%20render%2C%20high%20detail%2C%20premium%20gaming%20theme&width=800&height=600&seq=cat-jackpot-01&orientation=landscape",
  },
];

export const vipTiers = [
  {
    tier: "银卡会员",
    icon: "ri-medal-line",
    benefits: ["专属客服通道", "生日专属礼遇", "每日签到奖励", "1%返水优惠"],
    color: "bg-secondary-500",
    textColor: "text-secondary-700",
  },
  {
    tier: "金卡会员",
    icon: "ri-medal-fill",
    benefits: ["全部银卡权益", "优先提款处理", "月度专属活动", "3%返水优惠", "专属晋级奖励"],
    color: "bg-primary-500",
    textColor: "text-primary-700",
  },
  {
    tier: "钻石会员",
    icon: "ri-vip-diamond-line",
    benefits: ["全部金卡权益", "1对1专属经理", "私人定制活动", "5%返水优惠", "VIP专属赛事", "豪华旅行礼遇"],
    color: "bg-accent-500",
    textColor: "text-accent-700",
  },
];

export const securityFeatures = [
  {
    icon: "ri-lock-line",
    title: "数据加密",
    description: "256位SSL加密技术，全方位保护您的个人信息与交易数据安全。",
  },
  {
    icon: "ri-verified-badge-line",
    title: "权威认证",
    description: "所有游戏均通过国际权威机构BMM与GLI的严格认证，确保公平公正。",
  },
  {
    icon: "ri-bank-line",
    title: "资金安全",
    description: "多重资金隔离机制，与知名银行合作，确保您的资金安全无忧。",
  },
  {
    icon: "ri-mental-health-line",
    title: "责任博彩",
    description: "提供完善的自我限制工具与专业咨询服务，倡导健康的娱乐方式。",
  },
];

export const testimonials = [
  {
    name: "张先生",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20portrait%2C%20friendly%20smile%2C%20neutral%20gray%20background%2C%20headshot%20photography%2C%20clean%20professional%20look&width=100&height=100&seq=avatar-01&orientation=squarish",
    comment: "在银河娱乐玩了三年了，游戏种类丰富，提款速度也很快，客服服务态度非常好，强烈推荐！",
    rating: 5,
  },
  {
    name: "李女士",
    avatar: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20neutral%20gray%20background%2C%20headshot%20photography%2C%20natural%20lighting%2C%20professional%20look&width=100&height=100&seq=avatar-02&orientation=squarish",
    comment: "会员福利真的很好，生日的时候收到了专属礼遇和祝福，感觉非常贴心。",
    rating: 5,
  },
  {
    name: "王先生",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20confident%20expression%2C%20neutral%20gray%20background%2C%20headshot%20photography%2C%20casual%20professional%20style&width=100&height=100&seq=avatar-03&orientation=squarish",
    comment: "真人荷官体验太真实了，画面清晰流畅，跟现场赌场没什么区别，宅家就能享受！",
    rating: 5,
  },
];